import React, {useContext, useEffect, useState} from "react";
import {Menu, type MenuProps, theme} from "antd";
import Sider from "antd/es/layout/Sider";
import {RiBardLine, RiFileSearchLine, RiSearchEyeLine} from "react-icons/ri";
import {TiDocumentText} from "react-icons/ti";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import {AuthContext} from "../../../../config/AuthContext";
import {IoPeopleOutline} from "react-icons/io5";
import {MdQueryStats} from "react-icons/md";

interface Props {
    setPantalla: (value: number) => void;
}

const AppSiderProblemesId = (props: Props) => {
    const {isLoggedIn, userId, user, setBreadCrumb} = useContext(AuthContext);
    const [pantalla, setPantalla] = useState(0);
    const navigate = useNavigate();

    useEffect(() => {
        document.title = 'Web Dubtes';
    }, []);

    const titles: string[] = ['Enunciat', 'Exemple E/S', 'Estadístiques'];
    const titlesProfe: string[] = ['Enunciat', 'Exemple E/S', 'Estadístiques', 'Alumnes'];

    const baseItems: MenuProps['items'] = [
        {
            key: 'back',
            icon: <FaArrowLeft />,
            label: 'Tornar enrere',
            onClick: () => navigate('/jutge/problemes')
        },
        {
            type: 'divider'
        }
    ];

    const studentItems = [TiDocumentText, RiFileSearchLine, MdQueryStats].map(
        (icon, index) => {
            const key = String(index + 1);

            return {
                key: key,
                icon: React.createElement(icon),
                label: titles[index],
                onClick: () => (setPantalla(index), props.setPantalla(index))
            };
        },
    );

    const teacherItems = [TiDocumentText, RiFileSearchLine, MdQueryStats, IoPeopleOutline].map(
        (icon, index) => {
            const key = String(index + 1);

            return {
                key: key,
                icon: React.createElement(icon),
                label: titlesProfe[index],
                onClick: () => (setPantalla(index), props.setPantalla(index))
            };
        },
    );

    const items: MenuProps['items'] = [...baseItems, ...studentItems];
    const itemsProfe: MenuProps['items'] = [...baseItems, ...teacherItems];

    const {
        token: {colorBgContainer, borderRadiusLG},
    } = theme.useToken();

    return (
        <Sider style={{background: colorBgContainer}} width={200}>
            <Menu
                mode="inline"
                defaultSelectedKeys={[(pantalla + 1) + ""]}
                defaultOpenKeys={['sub1']}
                style={{height: '100%'}}
                items={user.tipus === "0" || user.tipus === "1" ? itemsProfe : items}
            />
        </Sider>
    );
}

export default AppSiderProblemesId;